export default __webpack_public_path__ + "static/media/Profile-documentation.0a916caf.md";